import { useEffect } from "react";
import { SocketClient } from "../core/api/socket-client";
import { useQueryClient } from "@tanstack/react-query";
import { TokenStorage } from "@/core/api";

export const useSocketConnection = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socketClient = SocketClient.getInstance();
    socketClient.setQueryClient(queryClient);

    // Funzione per gestire la connessione
    const connectSocket = () => {
      const token = TokenStorage.getAccessToken();
      console.log("Current token:", token); // Debug
      socketClient.connect(token);
    };

    // Connetti subito
    connectSocket();

    // Gestisci la riconnessione quando il token cambia
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === TokenStorage.ACCESS_TOKEN_KEY) {
        connectSocket();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      socketClient.disconnect();
    };
  }, [queryClient, TokenStorage.getAccessToken()]);
};
